import React, { ReactNode } from 'react';

import colors from 'styles/themes/colors';
import { ParentTopicTypes, SubTopicTypes } from 'topics';

import { TReactNodeResult } from 'types/shared';
import { ITopicFilterState } from 'components/TopicFilters/shared';
import { ViewSettings } from 'schemas/componentSettings/viewSettings';

export const defaultColors = {
  /** compareColors are used as a sequence when comparing entities/countries. This array can be altered by adding/removing entities/countries */
  compareColors: [
    colors.Blue,
    colors.CanaryYellow,
    colors.Magenta,
    colors.Cyan,
  ],
  /** These are the default colors used in series and also when only a single datapoint is displayed. */
  seriesColors: [
    colors.Blue,
    colors.CanaryYellow,
    colors.Magenta,
    colors.Cyan,
    colors.PeachOrange,
    colors.VioletPurple,
    colors.PaleGreen,
    colors.VibrantOrange,
  ],
};

export type SalesTypes = 'streaming' | 'downloads' | 'physical' | 'equivalents';

export type EntityTypes =
  | 'artist'
  | 'track'
  | 'release'
  | 'album'
  | 'project'
  | 'label';

export type CompareModes = 'country' | 'entity';

export type ContextTopics =
  | [ParentTopicTypes]
  | [ParentTopicTypes, SubTopicTypes];

export type CustomRegionFilterType =
  | string
  | number
  | boolean
  | (string | number | boolean | null)[]
  | null
  | undefined;

export interface IEntity {
  entityType: EntityTypes;
  entityIds: Array<string>;
  countryIds?: Array<number>;
  compareMode?: CompareModes;
  topic: ContextTopics; // index based types
  parentEntityId?: string;
  filters?: ITopicFilterState;
  viewSettings?: ViewSettings;
  isVersion: boolean;
  dataColors: Array<string>;
  customRegionFilter: CustomRegionFilterType;
}

export const EntityContext = React.createContext<IEntity>({
  entityType: 'track',
  entityIds: [],
  countryIds: [],
  compareMode: undefined,
  topic: [] as any,
  parentEntityId: undefined,
  filters: undefined,
  viewSettings: undefined,
  isVersion: false,
  dataColors: defaultColors.seriesColors,
  customRegionFilter: undefined,
});

export function withEntityContext(
  WrappedComponent: React.ComponentType
): TReactNodeResult<any> {
  return function WithSubscription(props: any): ReactNode {
    return (
      <EntityContext.Consumer>
        {(contextProps: any): ReactNode => (
          <WrappedComponent {...contextProps} {...props} />
        )}
      </EntityContext.Consumer>
    );
  };
}
